export default {"src":"/_next/static/media/Nerve and Muscle Disorders.f5ad261a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};